import React from 'react';
import Icon from '../../../components/AppIcon';

const EmergencyContactCard = ({ contact }) => {
  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg p-6 shadow-conservation hover:shadow-conservation-lg animation-organic">
      <div className="flex items-start gap-4">
        <div className="bg-primary/10 rounded-full p-3 flex-shrink-0">
          <Icon name={contact?.icon} size={24} className="text-primary" />
        </div>
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">{contact?.title}</h3>
          <p className="text-sm text-gray-600 dark:text-gray-300 mb-4">{contact?.description}</p>
          
          <div className="space-y-2">
            <a href={`tel:${contact?.phone}`} className="flex items-center gap-2 text-sm text-primary hover:text-accent animation-organic">
              <Icon name="Phone" size={16} />
              <span>{contact?.phone}</span>
            </a>
            <a href={`mailto:${contact?.email}`} className="flex items-center gap-2 text-sm text-primary hover:text-accent animation-organic">
              <Icon name="Mail" size={16} />
              <span>{contact?.email}</span>
            </a>
          </div>
          
          {contact?.available24x7 && (
            <div className="mt-3 flex items-center gap-2 text-xs text-success">
              <Icon name="Clock" size={14} />
              <span>Available 24/7</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmergencyContactCard;